import { expectNotNull } from "option-t/nullable";
import type { ReactNode } from "react";
import { createRoot } from "react-dom/client";

export const renderAppRoot = (children: ReactNode) =>
  createRoot(
    expectNotNull(
      document.getElementById("app-root"),
      "The index page should have a root element with the app-root id.",
    ),
  ).render(children);
